import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCLoader } from 'rollup-allspark';
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import MetricsCard from './MetricsCard';
import SectionCard from './components/SectionCard';
import reducer from './reducer';
import saga from './saga';
import * as selectors from './selectors';

const Metrics = ({
  brands,
  branches,
  analyticsProviders,
  summary,
  summaryLoading,
}) => {
  useInjectReducer({ key: 'nativeAnalytics', reducer });
  useInjectSaga({ key: 'nativeAnalytics', saga });

  // HOOKS
  // ======
  // USE-STATES
  const [metrics, setMetrics] = useState(null);
  const [selectedCountryIds, setSelectedCountryIds] = useState(null);
  // USE-EFFECTS
  useEffect(() => {
    if (summary && summary.metrics) {
      setMetrics(summary.metrics);
    }
  }, [summary]);
  useEffect(() => {
    const countryIds =
      branches && branches.length
        ? [...new Set(branches.map(eb => eb.country_id))]
        : [];
    setSelectedCountryIds(countryIds);
  }, [branches]);
  const getActiveCountryIds = activeBranchIds => {
    const activeCountryIds = branches
      .filter(branch => activeBranchIds.includes(branch.id))
      .map(branch => branch.country_id);
    return [...new Set(activeCountryIds)];
  };
  const renderLoader = (
    <div className="flex items-center justify-center h-48 w-full">
      <SCLoader lineWidth={5} diameter={50} />
    </div>
  );
  const renderActiveCount = (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <MetricsCard
        title="Brands"
        activeCount={
          metrics && metrics.active_brand_ids
            ? metrics.active_brand_ids.length
            : 0
        }
        total={brands && brands.length ? brands.length : 0}
      />
      <MetricsCard
        title="Branches"
        activeCount={
          metrics && metrics.active_branch_ids
            ? metrics.active_branch_ids.length
            : 0
        }
        total={branches && branches.length ? branches.length : 0}
      />
      <MetricsCard
        title="Aggregators"
        activeCount={
          metrics && metrics.active_provider_ids
            ? metrics.active_provider_ids.length
            : 0
        }
        total={
          analyticsProviders && analyticsProviders.length
            ? analyticsProviders.length
            : 0
        }
      />
      <MetricsCard
        title="Market"
        activeCount={
          metrics &&
          getActiveCountryIds(metrics ? metrics.active_branch_ids : []).length
            ? getActiveCountryIds(metrics ? metrics.active_branch_ids : [])
                .length
            : 0
        }
        total={selectedCountryIds ? selectedCountryIds.length : 0}
      />
    </div>
  );
  return (
    <SectionCard title="Active Brands, Branches, Aggregators & Markets">
      {summaryLoading ? renderLoader : renderActiveCount}
    </SectionCard>
  );
};
Metrics.propTypes = {
  brands: PropTypes.array,
  branches: PropTypes.array,
  analyticsProviders: PropTypes.array,
  summary: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  summaryLoading: PropTypes.bool,
};
const mapStateToProps = createStructuredSelector({
  brands: selectors.makeSelectAnalyticsBrands(),
  branches: selectors.makeSelectAnalyticsBranches(),
  analyticsProviders: selectors.makeSelectAnalyticsProviders(),
  summary: selectors.makeSelectSummary(),
  summaryLoading: selectors.makeSelectSummaryLoading(),
});
const withConnect = connect(mapStateToProps);
export default compose(withConnect)(Metrics);
